export default "__VITE_ASSET__Wg4auqFd__"